module.exports = __webpack_public_path__ + "img/mango-3.0cdf9c7d.png";